export const loadingBarConfig = ['cfpLoadingBarProvider',
(cfpLoadingBarProvider: any) => {
    cfpLoadingBarProvider.includeSpinner = false;
}];